"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f2360 = void 0;
exports.f2360 = {
    "संस्कृतम्": [
        6650
    ],
    "सिन्धी": [
        6742
    ]
};
